var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('Toolbar'),(_vm.authentified)?_c('Map'):_vm._e(),(!_vm.authentified)?_c('Auth',{on:{"authentify":_vm.authentify}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }